import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'yt-fw-please-wait',
  templateUrl: './please-wait.component.html'
})
export class PleaseWaitComponent implements OnInit {

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  @Input() ShowLoader: boolean;
  loaderReady = false;

  ngOnInit(): void {
  }

   ngAfterViewInit() {
    setTimeout(() => {
      this.loaderReady = true; 
      this.changeDetectorRef.markForCheck(); 
    }, 1000); 
  }

}
